import { Button } from "@coucou/ui";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { saveSession, type StoredSession } from "../lib/session";
import { api } from "../lib/trpc";

/**
 * Connexion equipe. Volontairement depouillee : le poste du salon se
 * reconnecte chaque matin, cet ecran doit se traverser en 5 secondes.
 */
export function SignIn({ onSignedIn }: { onSignedIn: (session: StoredSession) => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const signIn = useMutation({
    mutationFn: () => api.auth.signIn.mutate({ email, password, surface: "desktop" }),
    onSuccess: (result) => {
      if (!result.token) throw new Error("jeton absent");
      const session: StoredSession = {
        token: result.token,
        expiresAt: result.expiresAt.toISOString(),
        user: {
          id: result.user.id,
          firstName: result.user.firstName,
          role: result.user.role,
          salonId: result.user.salonId,
        },
      };
      saveSession(session);
      onSignedIn(session);
    },
  });

  return (
    <main className="flex min-h-dvh items-center justify-center bg-creme-100 p-6">
      <form
        onSubmit={(event) => {
          event.preventDefault();
          signIn.mutate();
        }}
        className="w-full max-w-sm animate-fade-up rounded-xl bg-white p-8 shadow-lift"
      >
        <p className="text-sm font-medium uppercase tracking-widest text-blush-600">
          Coucou Nails
        </p>
        <h1 className="mb-6 mt-1 text-3xl">Bonjour</h1>

        <label className="mb-4 block">
          <span className="mb-1.5 block text-sm font-medium text-encre-700">E-mail</span>
          <input
            type="email"
            autoComplete="username"
            autoFocus
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className="h-12 w-full rounded-lg border border-creme-300 px-4 outline-none focus:border-blush-400 focus:ring-2 focus:ring-blush-200"
          />
        </label>

        <label className="mb-6 block">
          <span className="mb-1.5 block text-sm font-medium text-encre-700">Mot de passe</span>
          <input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            className="h-12 w-full rounded-lg border border-creme-300 px-4 outline-none focus:border-blush-400 focus:ring-2 focus:ring-blush-200"
          />
        </label>

        {signIn.isError && (
          <p role="alert" className="mb-4 text-sm font-medium text-grenat-700">
            {signIn.error instanceof Error ? signIn.error.message : "Connexion impossible."}
          </p>
        )}

        <Button type="submit" block loading={signIn.isPending} size="lg">
          Ouvrir le salon
        </Button>
      </form>
    </main>
  );
}
